import { Form } from '@unform/web';
import styled from 'styled-components';

export const MapWrapper = styled.div`
  position: relative;
`;

export const DrawingToolbar = styled.div`
  position: absolute;
  top: 1rem;
  left: 50%;
  z-index: 2;

  display: flex;
  gap: 0.25rem;
  padding: 0.25rem;

  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transform: translateX(-50%);
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - ${(props) => (props.open ? '15rem' : '8rem')});
`;

export const MyForm = styled(Form)`
  display: ${(props) => (props.open ? 'flex' : 'none')};
  padding: 1.5rem 0;

  button {
    margin-left: 1.5rem;
  }
`;
